import { TokenService } from '../services/storage.service';
import { DocumentService } from '../services/document.service';
import { PROCCESSES_BASE_FOLDER_ID } from '../config/consts';
import BPMService from '../services/bpm.service';

// initial state
const state = {
    processesList: [],
    processesListLoading: false,
    processesList2: [],
    processesListLoading2: false,
    divisionsList: [],
    divisionsListLoading: false
};

// getters
const getters = {
    availableProcesses(state) {
        // TODO: доступность процессов в зависимости роли и прав
        return state.processesList;
    },
    availableProcesses2(state) {
        // TODO: доступность процессов в зависимости роли и прав
        return state.processesList2;
    },
    availableDivisions(state) {
        // TODO: доступность подразделений в зависимости роли и прав
        return state.divisionsList;
    },
};

// actions
const actions = {
    // загружает список доступных процессов (из папки "Все процессы")
    async intiProcessesList({ commit }) {
        if (TokenService.getToken()) {
            try {
                commit('setProcessesListLoading', true);
                // корнева папка "Все процессы"
                let data = await DocumentService.getDocumentFoldersTreeById(PROCCESSES_BASE_FOLDER_ID);
                commit('setProcessesList', data);
                return true;
            } catch (e) {
                console.log('bpm.intiProcessesList error: ' + e);
                return false;
            } finally {
                commit('setProcessesListLoading', false);
            }
        }
    },
    // загружает список доступных процессов (из папки "Все процессы")
    async intiProcessesList2({ commit }) {
        if (TokenService.getToken()) {
            try {
                commit('setProcessesListLoading2', true);
                // корнева папка "Все процессы"
                let data = await DocumentService.getDocumentFoldersTreeById2(PROCCESSES_BASE_FOLDER_ID);
                commit('setProcessesList2', data);
                return true;
            } catch (e) {
                console.log('bpm.intiProcessesList2 error: ' + e);
                return false;
            } finally {
                commit('setProcessesListLoading2', false);
            }
        }
    },
    // загружает список подразделений
    async initDivisionsList({ commit }) {
        if (TokenService.getToken()) {
            try {
                commit('setDivisionsListLoading', true);
                let data = await DocumentService.getDivisions();
                commit('setDivisionsList', data);
                return true;
            } catch (e) {
                console.log('bpm.initDivisionsList error: ' + e);
                return false;
            } finally {
                commit('setDivisionsListLoading', false);
            }
        }
    },
    async completeProcess({ commit }, { processId, data }) {
        return await BPMService.postTaskCompleteProcess(processId, data);
    }
};

// mutations
const mutations = {
    setProcessesList(state, data) {
        state.processesList = data;
    },
    setProcessesListLoading(state, data) {
        state.processesListLoading = data;
    },
    setProcessesList2(state, data) {
        state.processesList2 = data;
    },
    setProcessesListLoading2(state, data) {
        state.processesListLoading2 = data;
    },
    setDivisionsList(state, data) {
        state.divisionsList = data;
    },
    setDivisionsListLoading(state, data) {
        state.divisionsListLoading = data;
    },
};

export const bpm = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
